export const endPoints = {
  ANALYTIC_RATIO: '/v1/analytic/ratio',
  ANALYTIC_COUNT_OWN_OTHER: '/v1/analytic/count-own-other',
  ANALYTIC_COUNT_CONTRACT_LEAD: '/v1/analytic/count-contract-lead',
  ANALYTIC_BY_EMPLOYEE: '/v1/analytic/by-employee'
};
